export const TipoFormularioAvaliativo = {

  TYPEFORM: { id: 1, nome: 'Typeform' },
  AVALIA: { id: 2, nome: 'Avalia' }

}

export default TipoFormularioAvaliativo
